var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCovBrowserFriendly = function SvgCovBrowserFriendly(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133.043,
    height: 106.709,
    viewBox: "0 0 133.043 106.709",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-576.793 -416.135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.9-.9H132.143V105.809H-.9ZM130.343.9H.9V104.009H130.343Z",
    transform: "translate(577.693 417.034)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.238.9H-.9V-.9H118.238Z",
    transform: "translate(577.693 431.53)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.731.9H0V-.9H4.731Z",
    transform: "translate(585.928 424.494)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.731.9H0V-.9H4.731Z",
    transform: "translate(595.39 424.494)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.731.9H0V-.9H4.731Z",
    transform: "translate(604.852 424.494)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.026,459.013h-1.8V433.525H586.593v23.688h94.122v1.8H584.792V431.725H690.026Z",
    transform: "translate(5.905 11.507)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.9-.9H26.736V12.7H-.9ZM24.936.9H.9v10H24.936Z",
    transform: "translate(591.597 480.666)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.9-.9H26.736V12.7H-.9ZM24.936.9H.9v10H24.936Z",
    transform: "translate(630.396 480.666)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.9-.9H26.736V12.7H-.9ZM24.936.9H.9v10H24.936Z",
    transform: "translate(669.195 480.666)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.736.9H-.9V-.9H26.736Z",
    transform: "translate(591.597 500.981)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.155.9H-.9V-.9H14.155Z",
    transform: "translate(591.597 509.5)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.736.9H-.9V-.9H26.736Z",
    transform: "translate(630.396 500.981)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.155.9H-.9V-.9H14.155Z",
    transform: "translate(630.396 509.5)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.736.9H-.9V-.9H26.736Z",
    transform: "translate(669.195 500.981)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.155.9H-.9V-.9H14.155Z",
    transform: "translate(669.195 509.5)",
    fill: "#183149"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovBrowserFriendly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cov-browser-friendly.af98a3f1.svg";
export { ForwardRef as ReactComponent };